<div class="content max-h-6/10 flex flex-col gap-(--gap-relaxed) mb-(--space-4) overflow-visible w-full">
  @if (mode === 'bulk-edit') {
    <div class="mb-(--space-4)">
      @if (selectedAccessRights.length <= 3) {
        <!-- Affichage direct pour petites listes -->
        <div class="flex flex-col gap-(--gap-tight) text-sm text-(color:--text-secondary)">
          @for (accessRight of selectedAccessRights; track accessRight.id) {
            <div>{{ accessRight.assetGroupName + ' - ' + accessRight.assetName }}</div>
          }
        </div>
      } @else {
        <!-- Affichage compact avec expansion pour longues listes -->
        <div class="text-sm">
          <button
            type="button"
            [attr.aria-expanded]="showAssetList"
            class="flex items-center gap-(--gap-normal) text-(color:--text-secondary) hover:text-(color:--text-primary) cursor-pointer"
            (click)="toggleAssetList()">
            <span>{{ 'entities.access.messages.assetsAffected' | transloco: { count: selectedAccessRights.length } }}</span>
            <i class="pi" [class]="showAssetList ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
          </button>
          @if (showAssetList) {
            <div class="mt-(--space-2) flex flex-col gap-(--gap-tight) text-(color:--text-secondary)">
              @for (accessRight of selectedAccessRights; track accessRight.id) {
                <div>{{ accessRight.assetGroupName + ' - ' + accessRight.assetName }}</div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="flex w-full flex-col gap-(--gap-relaxed) flex-wrap">
    @if (isAssetContextCreate) {
      <div class="field-set flex flex-col gap-(--gap-normal) flex-wrap">
        <ces-select-field
          [options]="users"
          optionLabel="displayName"
          [(ngModel)]="selectedUser"
          (ngModelChange)="validate()"
          name="users"
          #userCtrl="ngModel"
          [label]="'entities.access.fields.user' | transloco"
          [filter]="true"
          [disabled]="users.length < 1"
          [pTooltip]="users.length < 1 ? ('common.tooltips.noOptionsAvailable' | transloco) : ''"
          tooltipPosition="top" />
      </div>
    }
    @if (isSyncMode) {
      <div class="field-set flex flex-col gap-(--gap-normal) flex-wrap">
        <ces-select-field
          [options]="groupedAssets"
          optionLabel="label"
          optionValue="value"
          [group]="true"
          optionGroupLabel="label"
          optionGroupChildren="items"
          [(ngModel)]="selectedAssets"
          (ngModelChange)="validate()"
          name="assets"
          #assetCtrl="ngModel"
          [label]="'entities.access.fields.asset' | transloco"
          [placeholder]="'common.placeholders.selectAsset' | transloco"
          [multiSelect]="true"
          [filter]="true"
          [disabled]="groupedAssets.length < 1"
          [pTooltip]="groupedAssets.length < 1 ? ('common.tooltips.noOptionsAvailable' | transloco) : ''"
          tooltipPosition="top" />
      </div>
    } @else if (isAssetContextCreate && !hasImplicitAsset) {
      <div class="field-set flex flex-col gap-(--gap-normal) flex-wrap">
        <ces-select-field
          [options]="assets"
          optionLabel="name"
          [(ngModel)]="selectedAsset"
          (ngModelChange)="validate()"
          name="asset"
          #assetCtrl="ngModel"
          [label]="'entities.access.fields.asset' | transloco"
          [placeholder]="'common.placeholders.selectAsset' | transloco"
          [required]="true"
          [filter]="true"
          [disabled]="assets.length < 1"
          [pTooltip]="assets.length < 1 ? ('common.tooltips.noOptionsAvailable' | transloco) : ''"
          tooltipPosition="top" />
      </div>
    }
    <div class="field-set flex flex-col gap-(--gap-normal) flex-wrap">
      <ces-select-field
        [options]="roles"
        optionLabel="name"
        [(ngModel)]="selectedRole"
        (ngModelChange)="onRoleChange()"
        name="role"
        [label]="'entities.access.fields.role' | transloco"
        [placeholder]="'common.placeholders.selectRole' | transloco"
        #roleCtrl="ngModel"
        [required]="true"
        [filter]="true"
        [disabled]="roles.length < 1"
        [pTooltip]="roles.length < 1 ? ('common.tooltips.noOptionsAvailable' | transloco) : ''"
        tooltipPosition="top" />
    </div>
    @if (mode !== 'bulk-edit' && mode !== 'create') {
      <div class="flex flex-row mt-(--space-2)">
        <ces-delete-button
          (confirm)="delete()"
          [disabled]="false"
          [confirmationConfig]="deleteConfig()"
          [label]="definition.messages.buttons.delete() | transloco"
          size="small" />
      </div>
    }
    @if (isAccessExisting) {
      <small class="text-red-500">{{ 'entities.access.messages.alreadyExists' | transloco }}</small>
    }
    <ces-dialog-footer
      [submitDisabled]="!isFormValid"
      [submitTooltip]="!isFormValid ? ('common.tooltips.formIncomplete' | transloco) : ''"
      (onSubmit)="submit()"
      (onCancel)="cancel()" />
  </div>
</div>
